// Browser localStorage glue for assist level (client-only).

import {
  ACTIVITY_DOCK_ASSIST_LEVEL_DEFAULT,
  ACTIVITY_DOCK_ASSIST_LEVEL_STORAGE_KEY,
  parseAssistLevel,
  type ActivityDockAssistLevel,
} from "./assistLevelTypes.js";

type Listener = (next: ActivityDockAssistLevel) => void;
const listeners = new Set<Listener>();

export function getAssistLevel(): ActivityDockAssistLevel {
  if (typeof localStorage === "undefined") {
    return ACTIVITY_DOCK_ASSIST_LEVEL_DEFAULT;
  }
  try {
    return parseAssistLevel(
      localStorage.getItem(ACTIVITY_DOCK_ASSIST_LEVEL_STORAGE_KEY),
    );
  } catch {
    return ACTIVITY_DOCK_ASSIST_LEVEL_DEFAULT;
  }
}

export function setAssistLevel(next: ActivityDockAssistLevel): void {
  if (typeof localStorage === "undefined") return;
  const value = parseAssistLevel(next);
  try {
    localStorage.setItem(ACTIVITY_DOCK_ASSIST_LEVEL_STORAGE_KEY, value);
  } catch {
    /* quota / private mode */
  }
  for (const listener of listeners) listener(value);
}

export function subscribeAssistLevel(listener: Listener): () => void {
  listeners.add(listener);
  let storageHandler: ((e: StorageEvent) => void) | null = null;
  if (typeof window !== "undefined") {
    storageHandler = (e) => {
      if (e.key !== ACTIVITY_DOCK_ASSIST_LEVEL_STORAGE_KEY) return;
      listener(parseAssistLevel(e.newValue));
    };
    window.addEventListener("storage", storageHandler);
  }
  return () => {
    listeners.delete(listener);
    if (storageHandler && typeof window !== "undefined") {
      window.removeEventListener("storage", storageHandler);
    }
  };
}
